<template>
  <div style="padding: 10px">
    <v-form data-vv-name="createForm">
      <v-card>
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon v-if="!isPrint">cancel</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm12 md4 style="padding: 10px">
              <span class="font-weight-bold">Số đề nghị: {{ createItem.requestNumber }}</span>
            </v-flex>
            <v-flex xs12 sm12 md4 style="padding: 10px">
              <span class="font-weight-bold">Ngày đề nghị: {{ createItem.requestDate | formatDate }}</span>
            </v-flex>
            <v-flex xs12 sm12 md4 style="padding: 10px">
              <span class="font-weight-bold">Người đề nghị mua hàng: {{ createItem.userCreateName }}</span>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md4 style="padding: 10px">
              <v-select :label="$t('lang.area.name')"
                        v-model.trim="createItem.areaId"
                        :items="lstArea"
                        v-validate="'required'"
                        name="areaId"
                        :data-vv-as="$t('lang.area.name')"
                        :error-messages="errors.first('areaId')"
                        item-text="categoryName"
                        item-value="categoryId"
                        @change="onChangeArea"
                        :disabled="!isEdit"
              />
            </v-flex>
            <v-flex md4 style="padding: 10px"
                    v-if="createItem.byProcess != 1 && createItem.byProcess != 2 && createItem.byProcess != 3">
              <v-select
                  :label="$t('lang.material.materialType')"
                  v-model="createItem.materialType"
                  :items="lstMaterialType"
                  item-text="categoryName"
                  item-value="categoryId"
                  v-validate="'required'"
                  name="materialType"
                  :data-vv-as="$t('lang.material.materialType')"
                  :error-messages="errors.first('materialType')"
                  multiple
                  :disabled="!isEdit"
                  @change="changeMaterialType($event)"
              />
            </v-flex>
            <v-flex md4 style="padding: 10px">
              <v-select
                  v-if="createItem.byProcess != 1 && createItem.byProcess != 2 && createItem.byProcess != 3"
                  :label="$t('lang.crop.name')"
                  v-model.trim="createItem.cropId"
                  v-validate="'required'"
                  :items="lstCrop"
                  item-text="name"
                  item-value="cropId"
                  name="crop"
                  :data-vv-as="$t('lang.crop.name')"
                  :error-messages="errors.first('crop')"
                  multiple
                  :disabled="!isEdit"
                  @change="changeCrop($event)"
              />
              <v-btn v-else-if="isEdit && (createItem.byProcess == 1 || createItem.byProcess == 3)"
                     color="primary"
                     @click="showSelectMaterial">
                Chọn vật tư
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout wrap
                    v-if="createItem.byProcess != 1 && createItem.byProcess != 2 && createItem.byProcess != 3">
            <v-flex md4 style="padding: 10px">
              <i-datepicker
                  :label="$t('lang.common.fromDate')"
                  v-model="createItem.startDate"
                  v-validate="'required'"
                  name="startDate"
                  :data-vv-as="$t('lang.common.fromDate')"
                  :error-messages="errors.first('startDate')"
                  :disabled="!isEdit"
                  @change="changeTime"
              />
            </v-flex>
            <v-flex md4 style="padding: 10px">
              <i-datepicker
                  :label="$t('lang.common.toDate')"
                  v-model="createItem.endDate"
                  v-validate="'required|endDateAfterStart'"
                  name="toDate"
                  :data-vv-as="$t('lang.common.toDate')"
                  :error-messages="errors.first('toDate')"
                  :disabled="!isEdit"
                  @change="changeTime"
              />
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex style="padding: 10px">
              <v-textarea
                  outlined
                  v-validate="'max:500'"
                  label="Nội dung"
                  rows="2"
                  v-model="createItem.content"
                  :disabled="!isEdit"
                  name="request_content"
                  data-vv-as="Nội dung"
                  :error-messages="errors.first('request_content')"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-tabs v-if="createItem.byProcess != 1 && createItem.byProcess != 2 && createItem.byProcess != 3"
                      v-model="tab"
                      slider-color="white"
                      style="padding: 10px"
              >
                <v-tabs-slider color="#2196F3"></v-tabs-slider>
                <v-tab
                    v-for="(item, key) in cropSelected"
                    :key="key"
                >
                  {{ item.name }}
                </v-tab>
                <v-tabs-items v-model="tab">
                  <v-tab-item
                      v-for="(item,key) in cropSelected"
                      :key="key"
                  >
                    <request-summary v-if="item.cropId == 0"
                                     :lstProcedureWh="lstProcedureWh"
                                     ref="summary"
                                     :materialTypeSelected="materialTypeSelected"
                                     :by-process="createItem.byProcess"
                                     :status="createItem.status"
                                     :creator="createItem.userCreateId"
                                     :is-edit="isEdit"
                                     @updateMaterialType="updateMaterialTypeAfterDelete"
                    />
                    <crop-tab-content v-else
                                      :crop="item"
                                      :request-data="requestData"
                                      :req-ord-id="createItem.reqOrdId"
                                      :is-edit="isEdit"
                                      :lstProcedureWh="lstProcedureWh"
                                      :materialTypeSelected="materialTypeSelected"
                                      :from-date="createItem.startDate"
                                      :to-date="createItem.endDate"
                                      :seed-number="seedNumber"
                                      @onload="onLoadCropData"
                                      ref="cropTab"
                    />
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>

              <request-summary
                  v-else-if="createItem.byProcess != 3"
                  :lstProcedureWh="lstProcedureWh"
                  ref="summary"
                  :materialTypeSelected="materialTypeSelected"
                  :by-process="createItem.byProcess"
                  :status="createItem.status"
                  :creator="createItem.userCreateId"
                  :is-edit="isEdit"
                  @updateMaterialType="updateMaterialTypeAfterDelete"
              />

              <request-service
                  v-else
                  :lstProcedureWh="lstProcedureWh"
                  ref="summaryService"
                  :materialTypeSelected="materialTypeSelected"
                  :by-process="createItem.byProcess"
                  :status="createItem.status"
                  :creator="createItem.userCreateId"
                  :is-edit="isEdit"
                  @updateMaterialType="updateMaterialTypeAfterDelete"
              />

            </v-flex>
          </v-layout>
          <v-layout wrap v-if="createItem.byProcess != 2">
            <v-flex style="padding: 10px">
              <v-textarea
                  :label="$t('lang.common.note')"
                  v-model="createItem.notes"
                  v-validate="'max:500'"
                  name="request_note"
                  :data-vv-as="$t('lang.common.note')"
                  :error-messages="errors.first('request_note')"
              />
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="info" @click="historyDlg=true"
                 v-if="createItem.reqOrdId != undefined && createItem.reqOrdId != null">
            {{ $t("lang.common.history") }}
          </v-btn>
          <v-btn color="primary" @click="onApprove" v-if="isApprove">
            {{ $t("lang.common.approve") }}
          </v-btn>
          <v-btn color="primary" @click="onCheck" v-if="!isEdit && isCheck">
            {{ $t("lang.common.confirm") }}
          </v-btn>
          <v-btn color="primary" @click="onCheck"
                 v-if="!isEdit && $store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE && (this.createItem.status == 2 ||this.createItem.status == 4)">
            {{ $t("lang.common.update") }}
          </v-btn>
          <v-btn color="error" @click="onReject" v-if="isApprove">
            {{ $t("lang.common.notApprove") }}
          </v-btn>
          <v-btn color="error" @click="onReject"
                 v-if="($store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR ||  $store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT) && this.createItem.status == 4">
            {{ $t("lang.common.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="onCopy"
                 v-if="createItem.status==3 && (createItem.userCreateId == $store.state.auth.user.userId || isEngineer)">
            {{ $t("lang.purchase.createNew") }}
          </v-btn>
          <v-btn color="red" dark @click="onDelete"
                 v-if="createItem.reqOrdId != null && (createItem.userCreateId == $store.state.auth.user.userId || isEngineer ) && (createItem.status == 3 || createItem.status == 1 || createItem.status == 2)">
            {{ $t("lang.common.delete") }}
          </v-btn>

          <v-btn color="primary" @click="onSave" v-if="isEdit && createItem.reqOrdId == null">
            {{ $t("lang.purchase.create") }}
          </v-btn>
          <v-btn color="primary" @click="onSave" v-if="isEdit && createItem.reqOrdId != null">
            {{ $t("lang.common.update") }}
          </v-btn>
          <v-btn color="orange" dark @click="onNote" v-if="createItem.reqOrdId != null">
            {{ $t("lang.common.note") }}
          </v-btn>
          <v-btn color="secondary" @click="onPrint"
                 v-if=" (createItem.status == 4 || createItem.status == 5 || createItem.status == 6)">
            {{ $t("lang.common.print") }}
          </v-btn>
          <v-btn @click="onCancel" v-if="!isPrint">
            {{ $t("lang.common.back") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <v-dialog v-model="rejectDlg" width="800px" persistent>
      <v-form data-vv-name="rejectForm">
        <v-card>
          <div class="headline dialog-header">
            <v-toolbar color="primary" dark>
              <v-toolbar-title style="padding-left: 10px">
                Từ chối đề nghị mua hàng
              </v-toolbar-title>
            </v-toolbar>
            <v-btn
                @click="rejectDlg=false"
                icon
                style="position: absolute; right: 10px; top: 10px; color: #fff"
            >
              <v-icon>cancel</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-textarea
                :label="$t('lang.common.reason')"
                :data-vv-as="$t('lang.common.reason')"
                v-validate="'max:2000'"
                name="reason"
                maxlength="2000"
                :error-messages="errors.first('reason')"
                v-model="createItem.rejectReason"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="red" dark @click="onRejectConfirm">{{ $t('lang.request.cancelRequest') }}</v-btn>
            <v-btn @click="rejectDlg=false">{{ $t('lang.common.cancel') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="historyDlg" width="800px" persistent>
      <v-form data-vv-name="historyForm">
        <v-card>
          <div class="headline dialog-header">
            <v-toolbar color="primary" dark>
              <v-toolbar-title style="padding-left: 10px">
                Lịch sử phiếu đề nghị mua hàng
              </v-toolbar-title>
            </v-toolbar>
            <v-btn
                @click="historyDlg=false"
                icon
                style="position: absolute; right: 10px; top: 10px; color: #fff"
            >
              <v-icon>cancel</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <table class="lstTable" v-if="lstHistory.length>0">
              <tr>
                <th width="20%">Thời gian</th>
                <th width="15%">Người xử lý</th>
                <th width="15%">Xử lý</th>
                <th width="50%">Nội dung</th>
              </tr>
              <tr v-for="item in lstHistory">
                <td>{{ item.actionTime|formatDateTime }}</td>
                <td><label style="font-weight: bold;color:blue">{{ item.userName }}</label></td>
                <td>{{ item.action }}</td>
                <td><label v-if="item.actionContent"> {{ item.actionContent }}</label></td>
              </tr>
            </table>
            <div v-else style="border:1px solid grey;border-radius: 10px;padding: 10px">Không có lịch sử
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn @click="historyDlg=false">{{ $t('lang.common.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <material-list
        :cDialog="materialDlg"
        :selected-items="requestData.lstMaterial"
        @select="onSelectMaterial"
        @closeDialog="closeMaterialListDialog"
        @openMaterialCreateDialog="openMaterialCreateDialog"
        ref="materialSelectCpn"
    />

    <request-note ref="requestNote"/>
  </div>
</template>

<script>
import axios from "axios";
import IDatepicker from "../../../components/form/DatePicker";
import {roleConstants} from "@/constants";
import {message} from "../../../shared/message";
import CropTabContent from "./component/CropTabContent.vue";
import RequestSummary from "./component/RequestSummary";
import {Validator} from "vee-validate";
import moment from "moment";
import MaterialList from "./component/MaterialList";
import {requestConstants} from "../../../constants";
import RequestNote from "./component/RequestNote";
import RequestService from "./component/RequestService";

export default {
  name: "RequestOrderCreate",
  components: {RequestService, RequestNote, MaterialList, RequestSummary, IDatepicker, CropTabContent},
  props: {},

  data: () => {
    return {
      isEdit: true,
      isPrint: false,
      cropSelected: [
        {
          cropId: 0,
          name: 'Tổng hợp',
        }
      ],
      materialDlg: false,
      materialTypeSelected: [],
      lstArea: [],
      lstCrop: [],
      lstMaterialType: [],
      lstProcedureWh: [],
      lstWarehouseItem: [],
      tab: null,
      seedNumber: [],
      items: [
        'web', 'shopping', 'videos', 'images', 'news',
      ],
      lstHistory: [],
      requestData: {
        lstCrop: [],
        lstMaterial: [],
      },
      createItem: {
        areaId: '',
        materialType: '',
        cropId: '',
        startDate: '',
        endDate: '',
        content: '',
      },
      rejectDlg: false,
      historyDlg: false
    };
  },

  watch: {},

  mounted() {
    Validator.extend("endDateAfterStart", {
      validate: (value, {otherValue}) => {
        let mm = moment(value).hour(23).minute(59).second(59);
        let valid = mm.isSameOrAfter(this.createItem.startDate); // false
        return {
          valid: valid,
          data: {
            message: "Đến ngày phải sau Từ ngày"
          }
        };
      },
      getMessage: (field, params, data) => {
        return "Đến ngày phải sau Từ ngày";
      }
    });
  },

  computed: {
    formName() {
      if (this.createItem.byProcess == 1) {
        return "Đề nghị mua hàng không theo quy trình";
      } else if (this.createItem.byProcess == 2) {
        return "Đề nghị mua hàng bổ sung";
      } else if (this.createItem.byProcess == 3) {
        return "Đề nghị mua hàng dịch vụ";
      } else {
        return "Đề nghị mua hàng theo quy trình";
      }
    },

    isCheck() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE && this.createItem.status == 1) {
        return true;
      } else {
        return false;
      }
    },

    isApprove() {
      if ((this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT) && this.createItem.status == 2) {
        return true;
      } else {
        return false;
      }
    },

    isEngineer() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER) {
        return true;
      } else {
        return false;
      }
    }
  },

  created() {
    this.requestConstants = requestConstants;
    this.roleConstants = roleConstants;
    //this.getMaterialType();
    this.getArea();
    this.getProcedureWh();
    this.getSeedNumber();
    let reqOrderId = this.$route.params.id;

    if (reqOrderId != undefined && reqOrderId != null && reqOrderId != "") {
      this.isPrint = true;
      axios.post(process.env.VUE_APP_API_URL + "/requestOrder/detail/" + reqOrderId).then(
          data => {
            // console.log(data);
            this.viewOrder(data);
          }
      )
    } else {
      this.isPrint = false;
    }
  },

  methods: {
    getRequestNumber() {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=ĐNM"
      ).then((data) => {
        this.createItem.requestNumber = "ĐNM/" + data;
      });
    },

    viewOrder(item) {
      this.isEdit = false;
      console.log("--- onview --- ");
      console.log(item);
      // console.log(this.isEdit);
      // this.tab = 0;
      this.loadOrderData(item);
    },

    editOrder(item, byProcess) {
      this.isEdit = true;
      this.tab = 0;
      this.loadOrderData(item, byProcess);
      this.$validator.reset();
    },

    getWarehouseRemain() {
      let ids = null;
      for (let i = 0; i < this.requestData.lstMaterial.length; i++) {
        if (this.requestData.lstMaterial[i].materialId != undefined && this.requestData.lstMaterial[i].materialId != null) {
          if (ids == null) {
            ids = this.requestData.lstMaterial[i].materialId;
          } else {
            ids += "," + this.requestData.lstMaterial[i].materialId;
          }
        }
      }
      //console.log(ids);
      //console.log(this.requestData);
      let url = process.env.VUE_APP_API_URL + "/warehouse/byAreaAndMateriaIds?ids=" + ids + "&areaId=" + this.createItem.areaId;
      axios.post(url).then(
          data => {
            this.lstWarehouseItem = data;
            /*
                                    console.log("--- before update remain ---");
                                    console.log(Object.assign({},this.requestData.lstMaterial));
            */
            // console.log(this.createItem.byProcess);

            for (let i = 0; i < this.requestData.lstMaterial.length; i++) {
              if (this.requestData.lstMaterial[i].materialId != undefined && this.requestData.lstMaterial[i].materialId != null) {
                for (let j = 0; j < this.lstWarehouseItem.length; j++) {
                  if (this.requestData.lstMaterial[i].materialId == this.lstWarehouseItem[j].materialId) {
                    this.requestData.lstMaterial[i].remain = this.lstWarehouseItem[j].quantity;
                    if (this.requestData.lstMaterial[i].remain == undefined
                        || this.requestData.lstMaterial[i].remain == null
                        || this.requestData.lstMaterial[i].remain === "") {
                      //console.log(this.requestData.lstMaterial[h].remain);
                      this.requestData.lstMaterial[i].remain = 0;
                    }
                    if (this.requestData.lstMaterial[i].reserved == undefined
                        || this.requestData.lstMaterial[i].reserved == null
                        || this.requestData.lstMaterial[i].reserved === "") {
                      this.requestData.lstMaterial[i].reserved = 0;
                    }

                    if (this.requestData.lstMaterial[i].materialId == 311) {
                      let item = this.requestData.lstMaterial[i];
                      // console.log("--- item ---");
                      // console.log(item);
                      // console.log(item.total);
                      // console.log(item.reserved);
                      // console.log(item.buyNumber);
                      // console.log(item.buyNumberPropose);
                      // console.log(item.remain);
                      // console.log("--- end item ---");
                    }
                    if (this.createItem.byProcess == 1) {
                      //
                      // mua hang ko quy trình
                      //
                      this.requestData.lstMaterial[i].buyNumberPropose = parseFloat(this.requestData.lstMaterial[i].buyNumber) - parseFloat(this.requestData.lstMaterial[i].remain);
                      if (this.requestData.lstMaterial[i].buyNumberPropose < 0) {
                        this.requestData.lstMaterial[i].buyNumberPropose = 0;
                      }
                    } else if (this.createItem.byProcess == 3) {
                      //
                      // mua hang dich vu
                      //

                    } else {
                      this.requestData.lstMaterial[i].buyNumber = (parseFloat(this.requestData.lstMaterial[i].total) + parseFloat(this.requestData.lstMaterial[i].reserved)) - parseFloat(this.requestData.lstMaterial[i].remain);
                      this.requestData.lstMaterial[i].buyNumber = parseFloat(this.requestData.lstMaterial[i].buyNumber.toFixed(2));
                      if (this.requestData.lstMaterial[i].buyNumber < 0) {
                        this.requestData.lstMaterial[i].buyNumber = 0;
                      }
                      this.requestData.lstMaterial[i].buyNumberPropose = this.requestData.lstMaterial[i].buyNumber;
                    }
                    break;
                  }
                }
              }
            }
            /*
                                    console.log("--- udpate warehouse remain ---");
                                    console.log(this.requestData.lstMaterial);
            */
            this.updateSummary();
          }
      )
    },

    onCopy() {
      let newItem = this.createItem;
      newItem.reqOrdId = null;
      newItem.requestNumber = null;
      newItem.requestDate = new Date();
      newItem.status = 1;
      this.editOrder(newItem);
      this.getRequestNumber();
    },

    loadOrderData(item, byProcess) {
      console.log("------loadOrderData----------");
      // console.log(item);
      // return false;
      if (item == null) {
        let fromDate = (new Date()).setDate(new Date().getDate() + 7);
        let toDate = (new Date()).setDate(new Date().getDate() + 14);
        this.createItem = {
          requestDate: new Date(),
          byProcess: byProcess,
          requestNumber: null,
          startDate: fromDate,
          endDate: toDate,
          userCreateId: this.$store.state.auth.user.userId,
          userCreateName: this.$store.state.auth.user.fullName,
          status: 1,
        }
        //console.log(this.createItem);
        this.materialTypeSelected = [];
        this.cropSelected = [];
        this.requestData = {
          lstCrop: [],
          lstMaterial: [],
        };
        this.getRequestNumber();
        this.getMaterialType();
        this.reCalculate(true);
      } else {
        // if (typeof item.materialType == 'string' && item.materialType.length > 0) {
        // let materialType = JSON.parse(item.materialType);//.replace('[', '').replace(']', '');
        //materialType = materialType.split(",");
        // if (materialType.length > 0) {
        //     item.materialType = materialType;
        // }
        // }
        // console.log(item);
        this.createItem = item;
        this.getMaterialType();
        if (item.requestData != undefined && item.requestData != null) {
          this.requestData = JSON.parse(item.requestData);
          // console.log("--- begin ---");
           console.log(JSON.parse(item.requestData));
          // this.createItem.materialType = this.requestData.materialType;
          // this.createItem.cropId = this.requestData.cropId;

          //
          // load selectedCrop
          //
          this.cropSelected = [
            {
              cropId: 0,
              name: 'Tổng hợp',
            }
          ];

          for (let i = 0; i < this.requestData.lstCrop.length; i++) {
            this.cropSelected.push(this.requestData.lstCrop[i]);
          }
        }
        this.getCropList();
        this.getOrderHistory();
        this.calculateMaterialTypeSelected();

        this.$nextTick(() => {
          //this.reCalculate(false);
          this.updateSummary();
        })


        // console.log(this.createItem);
        //console.log(this.requestData);
      }
      ;

    },

    keyProcess($event) {
      const inputs = Array.from($event.target.form.querySelectorAll('input[type="number"]'));
      const index = inputs.indexOf($event.target);
      let id = $event.target.getAttribute("id");
      if (id.indexOf("am") >= 0) {
        id = id.replace("am", "pm");
      } else {
        id = id.replace("pm", "am");
      }
      switch ($event.keyCode) {
        case 37:
          // left
          if (index > 0) {
            inputs[index - 1].focus();
          }
          $event.preventDefault();
          break;
        case 38:
          // up
          document.getElementById(id).focus();
          $event.preventDefault();
          break;
        case 13:
          if (index < inputs.length - 1) {
            inputs[index + 1].focus();
          }
          $event.preventDefault();
          break;
        case 39:
          //right
          if (index < inputs.length - 1) {
            inputs[index + 1].focus();
          }
          $event.preventDefault();
          break;
        case 40:
          //down
          document.getElementById(id).focus();
          $event.preventDefault();
          break;
      }
    },

    getArea() {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/myArea"
      ).then(
          (data) => {
            if (data.length > 0) {
              this.lstArea = data;
            }
          }
      );
    },

    getSeedNumber() {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/listByType?type=SEEDNUMBER"
      )
          .then(
              (data) => {
                if (data.length > 0) {
                  this.seedNumber = data;
                  // let itemFields = this.fields.filter(function (e) {
                  //     return e.name == "seedNumber";
                  // });
                  // if (itemFields != undefined && itemFields.length > 0) {
                  //     itemFields[0].items = data;
                  // }
                }
              }
          );
    },

    getMaterialType() {
      let url = process.env.VUE_APP_API_URL + "/category/myMaterialType?code=VTN";
      if (this.createItem.byProcess == 1 || this.createItem.byProcess == 2 || this.createItem.byProcess == 3) {
        url = process.env.VUE_APP_API_URL + "/category/myMaterialType";
      }
      axios.post(url).then(
          (data) => {
            if (data.length > 0) {
              this.lstMaterialType = data;
              this.materialTypeSelected = [];

              if (this.createItem.materialType != null && this.createItem.materialType != undefined) {
                for (let i = 0; i < this.createItem.materialType.length; i++) {
                  for (let j = 0; j < this.lstMaterialType.length; j++) {
                    if (this.lstMaterialType[j].categoryId == this.createItem.materialType[i]) {
                      this.materialTypeSelected.push(this.lstMaterialType[j]);
                      break;
                    }
                  }
                }
              }


              console.log("--- after get material type");
              console.log(this.lstMaterialType);
              console.log(this.createItem.materialType);
              console.log(this.materialTypeSelected);
              this.calculateMaterialTypeSelected();
              this.$forceUpdate();
            }
          }
      );
    },

    getOrderHistory() {
      axios.post(
          process.env.VUE_APP_API_URL + "/requestOrder/searchHistory?requestOrderId=" + this.createItem.reqOrdId).then(
          (data) => {
            this.lstHistory = data;
          }
      );
    },

    onChangeArea() {
      if (this.createItem.byProcess != 1 && this.createItem.byProcess != 2) {
        this.getCropList();
      } else {
        this.getWarehouseRemain();
      }
    },

    getCropList() {
      axios.post(
          process.env.VUE_APP_API_URL + "/crop/search?pageSize=-1&page=-1&orderBy=asc", {
            pondAreaId: this.createItem.areaId,
            status: 1
          }
      ).then(
          (data) => {
            if (data.items) {
              this.lstCrop = data.items;
              /*
                                          if (this.createItem.cropId != null && this.createItem.cropId != "") {
                                              this.changeCrop();
                                          }
              */
            }
          }
      );
    },

    getProcedureWh() {
      axios.post(
          process.env.VUE_APP_API_URL + "/procedureWh/search?pageSize=-1&page=-1&orderBy=asc", {status: 1}
      ).then(
          (data) => {
            if (data.items) {
              this.lstProcedureWh = data.items;
            }
          }
      );
    },

    onCancel() {
      // this.createDlg = false;
      // this.onSearch();
      this.$emit("cancel");
    },

    onSave() {
      if (this.$validator.validateScopes("createForm").then(
          valid => {
            if (!valid) {
              return;
            }
            //
            // validate
            //
            if (this.createItem.byProcess != 2) {
              // console.log(this.requestData.lstMaterial);
              for (let i = 0; i < this.requestData.lstMaterial.length; i++) {
                if (this.requestData.lstMaterial[i].materialId != undefined && this.requestData.lstMaterial[i].materialId != null) {
                  let checkValue = this.requestData.lstMaterial[i].buyNumber;
                  if (this.createItem.byProcess == 3) {
                    checkValue = this.requestData.lstMaterial[i].buyNumberPropose;
                  }
                  if (checkValue == undefined
                      || checkValue == null
                      || isNaN(checkValue)
                  ) {
                    message.error("Chưa nhập đủ số lượng cần mua");
                    return;
                  }
                }
              }
              //
              // validate nhap price
              //
              if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE) {
                for (let i = 0; i < this.requestData.lstMaterial.length; i++) {
                  if (this.requestData.lstMaterial[i].materialId != undefined && this.requestData.lstMaterial[i].materialId != null) {
                    // console.log(this.requestData.lstMaterial[i].price);
                    if (this.requestData.lstMaterial[i].price == undefined
                        || this.requestData.lstMaterial[i].price == null
                        || this.requestData.lstMaterial[i].price === ""
                    ) {
                      message.error("Chưa nhập đủ đơn giá");
                      return;
                    }
                  }
                }
              }
            }
            this.requestData.materialType = this.createItem.materialType;
            console.log(this.createItem.materialType);
            if (Array.isArray(this.createItem.materialType)) {
              this.createItem.materialType = JSON.stringify(this.createItem.materialType);
            }
            console.log(this.createItem.materialType);
            this.requestData.cropId = this.createItem.cropId;
            this.createItem.requestData = JSON.stringify(this.requestData);

            axios.post(process.env.VUE_APP_API_URL + "/requestOrder/save", this.createItem).then(
                data => {
                  if (data.success) {
                    message.success("Lưu thành công");
                    this.onCancel();
                  } else {
                    message.error("Lưu không thành công");
                  }
                },
                error => {
                  message.error(error);
                }
            )
          })) ;
    },

    onCheck() {
      console.log(this.createItem.materialType);
      // return;
      for (let i = 0; i < this.requestData.lstMaterial.length; i++) {
        if (this.requestData.lstMaterial[i].materialId == undefined || this.requestData.lstMaterial[i].materialId == null) {
          //
          // do la hang rong
          //
          continue;
        }
        if (this.requestData.lstMaterial[i].show && this.requestData.lstMaterial[i].price == null || this.requestData.lstMaterial[i].price === "") {
          message.error("Chưa nhập đủ đơn giá");
          return;
        }
        if (this.requestData.lstMaterial[i].show && (this.requestData.lstMaterial[i].buyNumberPropose == null || this.requestData.lstMaterial[i].buyNumberPropose === "") && this.requestData.lstMaterial[i].buyNumberPropose != 0) {
          //console.log(this.requestData.lstMaterial[i].buyNumberPropose);
          message.error("Chưa nhập đủ số lượng đề xuất");
          return;
        }
      }
      if (confirm("Bạn có chắc muốn xác nhận đề nghị mua hàng?")) {

        this.requestData.materialType = this.createItem.materialType;
        //this.createItem.materialType = JSON.stringify(this.createItem.materialType);
        if (Array.isArray(this.createItem.materialType)) {
          this.createItem.materialType = JSON.stringify(this.createItem.materialType);
        }
        this.requestData.cropId = this.createItem.cropId;
        this.createItem.requestData = JSON.stringify(this.requestData);
        axios.post(process.env.VUE_APP_API_URL + "/requestOrder/check", this.createItem).then(
            data => {
              if (data.success) {
                message.success("Kiểm tra thành công");
                this.onCancel();
              } else {
                this.createItem.materialType = JSON.parse(this.createItem.materialType);
                message.error(data.description);
              }
            },
            error => {
              message.error(error);
            }
        )
      }
      ;

    },

    onApprove() {
      if (confirm("Bạn có chắc muốn phê duyệt đề nghị mua hàng?")) {
        this.requestData.materialType = this.createItem.materialType;
        if(Array.isArray(this.createItem.materialType)) {
          this.createItem.materialType = JSON.stringify(this.createItem.materialType);
        }
        this.requestData.cropId = this.createItem.cropId;
        this.createItem.requestData = JSON.stringify(this.requestData);
        axios.post(process.env.VUE_APP_API_URL + "/requestOrder/approve", this.createItem).then(
            data => {
              if (data.success) {
                message.success("Phê duyệt thành công");
                this.onCancel();
              }
            },
            error => {
              message.error(error);
            }
        )
      }
    },

    onReject() {
      this.rejectDlg = true;
    },

    onRejectConfirm() {
      if (this.createItem.rejectReason == null || this.createItem.rejectReason.trim() === "") {
        message.error("Bạn chưa nhập lý do hủy phiếu");
        return;
      }
      if (this.createItem.rejectReason.length > 2000) {
        message.error("Lý do quá dài");
        return;
      }
      if (confirm("Bạn có chắc muốn hủy phiếu đề nghị mua hàng?")) {
        this.requestData.materialType = this.createItem.materialType;
        this.requestData.cropId = this.createItem.cropId;
        this.createItem.requestData = JSON.stringify(this.requestData);
        if(Array.isArray(this.createItem.materialType)) {
          this.createItem.materialType = JSON.stringify(this.createItem.materialType);
        }
        axios.post(process.env.VUE_APP_API_URL + "/requestOrder/reject", this.createItem).then(
            data => {
              if (data.success) {
                message.success("Từ chối thành công");
                this.rejectDlg = false;
                this.onCancel();
              }
            },
            error => {
              message.error(error);
            }
        )
      }
    },

    onDelete() {
      if (confirm("Bạn có chắc muốn xóa đề nghị mua hàng?")) {
        //this.createItem.materialType = JSON.stringify(this.createItem.materialType);
        axios.post(process.env.VUE_APP_API_URL + "/requestOrder/delete", this.createItem).then(
            data => {
              if (data) {
                message.success("Xóa thành công");
                this.onCancel();
              } else {
                message.error("Xóa không thành công");
              }
            },
            error => {
              message.error(error);
            }
        )
      }

    },

    changeCrop() {
      let event = this.createItem.cropId;
      let cropSelected = [
        {
          cropId: 0,
          name: 'Tổng hợp',
        }
      ];

      const self = this;
      let listCrop = '';
      if (event.length > 0 && typeof event == 'object') {
        listCrop = event.join();
      }
      listCrop = ',' + listCrop + ','

      let srops = this.lstCrop.filter(function (e) {
        return listCrop.indexOf(',' + e.cropId + ',') != -1;
      });

      $.each(srops, function (k, v) {
        cropSelected.push({
          cropId: v.cropId,
          code: v.code,
          name: v.name,
          seedNumber: v.seedNumber,
          shrimpAge: v.shrimpAge,
          startDate: v.startDate,
          updatedAt: v.updatedAt,
          processId: v.processId,
          pondParent: v.pondParent,
          dropDateParent: v.dropDateParent,
          dropDate: v.dropDate,
          endDate: v.endDate,
        });
      });

      this.cropSelected = cropSelected;
      //
      // xoa data o cac crop bi loai bo
      //
      //console.log(this.requestData.lstCrop);
      //console.log(this.cropSelected);
      for (let i = this.requestData.lstCrop.length - 1; i >= 0; i--) {
        let bhas = false;
        for (let j = 0; j < this.cropSelected.length; j++) {
          if (this.requestData.lstCrop[i].cropId == this.cropSelected[j].cropId) {
            this.cropSelected[j].numberG = this.requestData.lstCrop[i].numberG;
            bhas = true;
            break;
          }
        }
        if (!bhas) {
          this.requestData.lstCrop.splice(i, 1);
          this.reCalculate(true);
        }
      }
      this.$nextTick(() => {
        this.reloadTabContent();
      })
      //console.log("--- change crop ---");
      //console.log(this.cropSelected);
    },

    calculateMaterialTypeSelected() {
      let event;
      //console.log(typeof this.createItem.materialType);
      if (Array.isArray(this.createItem.materialType)) {
        //console.log("is array");
        //event = this.createItem.materialType;
      } else {
        //console.log("is not an array");
        this.createItem.materialType = JSON.parse(this.createItem.materialType);
      }
      event = this.createItem.materialType;
      if (event == undefined || event == null) {
        return;
      }
/*
      console.log(event);
      console.log(event.length);
      console.log(event[0]);
      console.log(this.lstMaterialType);
*/
      let typeSelected = [];

      const self = this;
      let listTypeMat = '';
      if (event.length > 0 && typeof event == 'object') {
        listTypeMat = event.join();
      }
      listTypeMat = ',' + listTypeMat + ','

      let listMt = this.lstMaterialType.filter(function (e) {
        return listTypeMat.indexOf(',' + e.categoryId + ',') != -1;
      });

      $.each(listMt, function (k, v) {
        typeSelected.push({
          categoryId: v.categoryId,
          categoryName: v.categoryName,
        });
      });

      this.materialTypeSelected = typeSelected;
/*
      console.log("--- material type ---");
      console.log(this.materialTypeSelected);
*/
    },

    changeMaterialType() {
      this.calculateMaterialTypeSelected();
      this.reloadTabContent();
    },

    onLoadCropData(crop) {
      if (!this.isEdit) {
        //console.log("--- no load crop data");
        return;
      } else {
        //console.log(this.isEdit + "--- load crop data ---");
      }

      if ((this.createItem.reqOrdId == null && crop.reqOrdId != null)
          || (this.createItem.reqOrdId != null && crop.reqOrdId == null)
          || (this.createItem.reqOrdId != crop.reqOrdId)) {
        return;
      }
      let bHas = false;
      let bRecalculate = false;
      for (let i = 0; i < this.requestData.lstCrop.length; i++) {
        if (this.requestData.lstCrop[i].cropId == crop.cropId) {
          for (let j = 0; j < crop.lstMaterial.length; j++) {
            let bnew = true;
            for (let h = 0; h < this.requestData.lstCrop[i].lstMaterial.length; h++) {
              if (crop.lstMaterial[j].materialId == this.requestData.lstCrop[i].lstMaterial[h].materialId) {
                if (crop.lstMaterial[j].total != this.requestData.lstCrop[i].lstMaterial[h].total) {
                  //console.log("update by change total");
                  bRecalculate = true;
                }
                bnew = false;
                break;
              }
            }
            if (bnew) {
              //console.log("update by new");
              bRecalculate = true;
            }
          }
          /*
                                  console.log("--- update crop---");
                                  console.log(crop);
                                  console.log(this.requestData.lstCrop[i]);
          */
          this.requestData.lstCrop[i] = Object.assign({}, crop);
          bHas = true;
          break;
        }
      }
      if (!bHas) {
        //console.log("update by new crop");
        this.requestData.lstCrop.push(Object.assign({}, crop));
        bRecalculate = true;
      }
      //console.log(bRecalculate);
      /*
                      if(bRecalculate && (this.createItem.reqOrdId == null || this.createItem.reqOrdId == undefined)){
                          this.getWarehouseRemain();
                      }
      */
      //console.log("--- preload ---");
      this.reCalculate(bRecalculate);
      this.getWarehouseRemain();

    },

    reCalculate(calculateReserved) {

      for (let i = 0; i < this.requestData.lstMaterial.length; i++) {
        this.requestData.lstMaterial[i].total = 0;
        this.requestData.lstMaterial[i].row = 0;
      }
      //console.log(this.requestData);
      //console.log(this.requestData.lstMaterial);
      //this.requestData.lstMaterial = [];
      //
      // sum result from all crop
      //
      for (let i = 0; i < this.requestData.lstCrop.length; i++) {
        for (let j = 0; j < this.requestData.lstCrop[i].lstMaterial.length; j++) {
          if (this.requestData.lstCrop[i].lstMaterial[j].materialId == undefined || this.requestData.lstCrop[i].lstMaterial[j].materialId == null) {
            continue;
          }
          let bHas = false;
          for (let h = 0; h < this.requestData.lstMaterial.length; h++) {
            if (this.requestData.lstMaterial[h].materialId == this.requestData.lstCrop[i].lstMaterial[j].materialId) {
              this.requestData.lstMaterial[h].total += this.requestData.lstCrop[i].lstMaterial[j].total;
              this.requestData.lstMaterial[h].row = this.requestData.lstCrop[i].lstMaterial[j].row;
              bHas = true;
              break;
            }
          }
          if (!bHas && this.createItem.byProcess != 2) {
            //console.log(this.requestData.lstCrop[i].lstMaterial[j]);
            let added = false;
            for (let h = 0; h < this.requestData.lstMaterial.length; h++) {
              if (this.requestData.lstMaterial[h].typeId == this.requestData.lstCrop[i].lstMaterial[j].typeId
                  && (this.requestData.lstMaterial[h].materialId == undefined || this.requestData.lstMaterial[h].materialId == null)) {
                this.requestData.lstMaterial[h] = Object.assign({}, this.requestData.lstCrop[i].lstMaterial[j]);
                added = true;
                break;
              }
            }
            if (!added) {
              this.requestData.lstMaterial.push(Object.assign({}, this.requestData.lstCrop[i].lstMaterial[j]));
            }
            //console.log(this.requestData.lstMaterial);
          }
        }
      }


      for (let h = 0; h < this.requestData.lstMaterial.length; h++) {
        this.requestData.lstMaterial[h].total = parseFloat(this.requestData.lstMaterial[h].total.toFixed(2));
      }

      if (this.createItem.byProcess != 1 && this.createItem.byProcess != 3) {
        for (let h = this.requestData.lstMaterial.length - 1; h >= 0; h--) {
          if (this.requestData.lstMaterial[h].total == 0 && this.createItem.byProcess != 2) {
            this.requestData.lstMaterial.splice(h, 1);
          }
        }
      }

      if (calculateReserved) {
        for (let h = 0; h < this.requestData.lstMaterial.length; h++) {
          if (this.requestData.lstMaterial[h].materialName == 'Blanca 9994') {
            // console.log(this.requestData.lstMaterial[h]);
          }
          if (this.requestData.lstMaterial[h].remain == undefined || this.requestData.lstMaterial[h].remain == null) {
            //console.log(this.requestData.lstMaterial[h].remain);
            this.requestData.lstMaterial[h].remain = 0;
          }
          if (this.requestData.lstMaterial[h].materialId == 311) {
            // console.log("--- before update ---");
            // console.log(this.requestData.lstMaterial[h].buyNumber);
          }
          this.requestData.lstMaterial[h].reserved = parseFloat((this.requestData.lstMaterial[h].total / 10.0).toFixed(2));
          this.requestData.lstMaterial[h].buyNumber = (this.requestData.lstMaterial[h].total + this.requestData.lstMaterial[h].reserved) - parseFloat(this.requestData.lstMaterial[h].remain);
          this.requestData.lstMaterial[h].buyNumber = parseFloat(this.requestData.lstMaterial[h].buyNumber.toFixed(2));
          if (this.requestData.lstMaterial[h].buyNumber < 0) {
            this.requestData.lstMaterial[h].buyNumber = 0;
          }
          this.requestData.lstMaterial[h].buyNumberPropose = this.requestData.lstMaterial[h].buyNumber;
          if (this.requestData.lstMaterial[h].materialId == 311) {
            // console.log(this.requestData.lstMaterial[h].buyNumber);
            // console.log("--- after update ---");
          }
          /*
      if (this.requestData.lstMaterial[h].reserved == null || this.requestData.lstMaterial[h].reserved == "" || this.requestData.lstMaterial[h].reserved == undefined || this.requestData.lstMaterial[h].reserved == 0)
          this.requestData.lstMaterial[h].reserved = parseFloat((this.requestData.lstMaterial[h].total / 10.0).toFixed(2));
      if (this.requestData.lstMaterial[h].buyNumber == null || this.requestData.lstMaterial[h].buyNumber == "" || this.requestData.lstMaterial[h].buyNumber == undefined || this.requestData.lstMaterial[h].buyNumber == 0)
          this.requestData.lstMaterial[h].buyNumber = this.requestData.lstMaterial[h].total + this.requestData.lstMaterial[h].reserved;
      if (this.requestData.lstMaterial[h].buyNumberPropose == null)
          this.requestData.lstMaterial[h].buyNumberPropose = this.requestData.lstMaterial[h].buyNumber;

*/
        }
      }
      // console.log(this.requestData.lstMaterial);
      //
      // reload summary
      //
      this.updateSummary();
    },

    updateSummary() {
      console.log("--- update summary ---");
      console.log(this.requestData);
      console.log(this.createItem);
      if (this.createItem.byProcess == 1 || this.createItem.byProcess == 2) {
        this.$nextTick(() => {
          this.$refs.summary.viewProcedure(this.requestData);
        });
      } else if (this.createItem.byProcess == 3) {
        this.$nextTick(() => {
          this.$refs.summaryService.viewProcedure(this.requestData);
        });
      } else {
        this.$nextTick(() => {
          this.$refs.summary[0].viewProcedure(this.requestData);
        });
      }
    },

    showSelectMaterial() {
      this.materialDlg = true;
      this.$refs.materialSelectCpn.resetFrom();
    },

    closeMaterialListDialog() {
      this.materialDlg = false;
    },

    openMaterialCreateDialog() {

    },

    onSelectMaterial(lstSelectMaterial) {
      console.log("--- selected ---");
      console.log(lstSelectMaterial);
      for (let j = this.requestData.lstMaterial.length - 1; j >= 0; j--) {
        let bHas = false;
        for (let i = 0; i < lstSelectMaterial.length; i++) {
          if (this.requestData.lstMaterial[j].materialId == lstSelectMaterial[i].materialId) {
            bHas = true;
            break;
          }
        }
        if (!bHas) {
          this.requestData.lstMaterial.splice(j);
        }

      }
      for (let i = 0; i < lstSelectMaterial.length; i++) {
        let bHas = false;
        for (let j = 0; j < this.requestData.lstMaterial.length; j++) {
          if (this.requestData.lstMaterial[j].materialId == lstSelectMaterial[i].materialId) {
            bHas = true;
            break;
          }
        }
        if (!bHas) {
          // console.log("push");
          lstSelectMaterial[i].total = 0;
          lstSelectMaterial[i].row = 0;
          this.requestData.lstMaterial.push(lstSelectMaterial[i]);
          //
          // check material type if don't have push
          //
          let hasMaterialType = false;
          for (let j = 0; j < this.createItem.materialType.length; j++) {
            if (this.createItem.materialType[j] == lstSelectMaterial[i].typeId) {
              hasMaterialType = true;
              break;
            }
          }
          if (!hasMaterialType) {
            if (this.createItem.materialType == null || this.createItem.materialType == undefined) {
              this.createItem.materialType = [];
            }
            this.createItem.materialType.push(lstSelectMaterial[i].typeId);
            for (let j = 0; j < this.lstMaterialType.length; j++) {
              if (this.lstMaterialType[j].categoryId == lstSelectMaterial[i].typeId) {
                this.materialTypeSelected.push(this.lstMaterialType[j]);
              }
            }
          }
        }
      }
      console.log(this.createItem.materialType);

      //console.log("re calculate by change material");
      /*                if (this.createItem.reqOrdId == undefined || this.createItem.reqOrdId == null) {
                          this.getWarehouseRemain();
                          this.reCalculate(false);
                      } else {
                          this.reCalculate(false);
                      }*/
      this.getWarehouseRemain();
      this.reCalculate(false);

    },

    onNote() {
      this.$refs.requestNote.onShow(this.createItem.reqOrdId, 1);
    },

    changeTime() {
      this.reloadTabContent();
    },

    reloadTabContent() {
      if (this.createItem.byProcess == 0) {
        for (let i = 0; i < this.$refs.cropTab.length; i++) {
          this.$refs.cropTab[i].reload(this.createItem.startDate, this.createItem.endDate, this.materialTypeSelected);
        }
      }
    },

    updateMaterialTypeAfterDelete(item) {
      //
      // update materialType after delete material
      //
      let bDelete = true;
      for (let i = 0; i < this.requestData.lstMaterial.length; i++) {
        if (this.requestData.lstMaterial[i].typeId == item.typeId) {
          bDelete = false;
          break;
        }
      }
      if (bDelete) {
        for (let i = 0; i < this.createItem.materialType.length; i++) {
          if (this.createItem.materialType[i] == item.typeId) {
            this.createItem.materialType.splice(i, 1);
            break;
          }
        }

        for (let i = 0; i < this.materialTypeSelected.length; i++) {
          if (this.materialTypeSelected[i] == item.typeId) {
            this.materialTypeSelected.splice(i, 1);
            break;
          }
        }
      }

    },

    onPrint() {
      if (!this.isPrint) {
        this.$router.push("/requestOrderDetail/" + this.createItem.reqOrdId);
      } else {
        window.print();
      }

    }

  },

  destroyed() {
  },
};
</script>
